import { render, staticRenderFns } from "./OmplirQuartoEnEspera.vue?vue&type=template&id=f1b68c1a&scoped=true"
import script from "./OmplirQuartoEnEspera.vue?vue&type=script&lang=js"
export * from "./OmplirQuartoEnEspera.vue?vue&type=script&lang=js"
import style0 from "./OmplirQuartoEnEspera.vue?vue&type=style&index=0&id=f1b68c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b68c1a",
  null
  
)

export default component.exports